import { render } from "./VolForm.vue?vue&type=template&id=2d44cabb&scoped=true"
import script from "./VolForm.vue?vue&type=script&lang=js"
export * from "./VolForm.vue?vue&type=script&lang=js"

import "./VolForm.vue?vue&type=style&index=0&id=2d44cabb&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d44cabb"]])

export default __exports__